var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"card-header"},[_c('span',[_vm._v("今日菜品")])]),_c('TodayMenuList',{attrs:{"menu-list":_vm.menuList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }